import { GlobalReviewStatisticsFragment } from '#src/generated/graphql'
import sortBy from 'lodash/sortBy'

function getReviewBuckets(globalReviewStatistics: GlobalReviewStatisticsFragment) {
  const reviewSummaryBuckets = globalReviewStatistics.facets.find(facet => facet.name === 'rating')
  if (reviewSummaryBuckets && 'buckets' in reviewSummaryBuckets) {
    const reviewBuckets = sortBy(reviewSummaryBuckets.buckets, [bucket => bucket.value])
    return reviewBuckets
  } else {
    return null
  }
}

export function getTotalReviewCount(globalReviewStatistics: GlobalReviewStatisticsFragment) {
  const reviewBuckets = getReviewBuckets(globalReviewStatistics)

  if (reviewBuckets) {
    const totalReviews = reviewBuckets.reduce((sum, bucket) => sum + bucket.count, 0)
    return totalReviews
  } else {
    return null
  }
}

export function getAverageReviewRating(globalReviewStatistics: GlobalReviewStatisticsFragment) {
  const reviewBuckets = getReviewBuckets(globalReviewStatistics)
  const totalReviews = getTotalReviewCount(globalReviewStatistics)

  if (reviewBuckets && totalReviews) {
    const averageRating =
      reviewBuckets.reduce((sum, bucket) => sum + parseInt(bucket.value, 10) * bucket.count, 0) /
      totalReviews
    return averageRating
  } else {
    return null
  }
}
